export const getColor = (val) => {
    let colorPositivo = "#5f9658"
    let colorNegativo = '#EA3C3E'

    return val > 0 ? colorPositivo : colorNegativo
}